import {
  SYNC_USER_PROFILE_SUCCESS,
  SYNC_USER_PROFILE_FAILURE,
  SYNC_USER_PROFILE_RESET
} from "../actionTypes/index";

const initialState = {
  userDetails: null,
};

const userProfileSync = (state = initialState, { type, payload }) => {
  switch (type) {
    case SYNC_USER_PROFILE_SUCCESS:
      return { ...state, userDetails: { ...payload, apiStatus: true} };
    case SYNC_USER_PROFILE_FAILURE:
      return { ...state, userDetails: { ...payload, apiStatus: false} };
    case SYNC_USER_PROFILE_RESET:
      return { ...state, userDetails: null };
    default:
      return state;
  }
};

export default userProfileSync;
